import React from 'react';
import PropTypes from 'prop-types';
import { pastMeetsColumns } from 'config/admin/athleteDashboard';
import { pastMeetsData } from 'services/admin/AthleteDashboardService';
import AdminDataTable from 'components/admin/AdminDataTable';
import useGroupLabels from 'hooks/useGroupLabels';

const AthletePastMeet = ({
  pastMeets,
  seasonName,
  clubId,
  openPopup,
  isCurrentSeason = true,
}) => {
  // The highest group number the club places by age: a result above it is an adult's, and links to the event
  // view, not the age view. See utils/groupLabel.js.
  const { oldestPlacedByAge } = useGroupLabels(clubId);

  if (!pastMeets?.length) return null;

  return (
    <>
      <div style={{ marginBottom: '20px', marginTop: '36px' }}>
        <h2
          className="heading2"
          style={{
            margin: '0 0 8px 0',
            fontSize: '20px',
            fontWeight: '600',
            color: '#212529',
          }}
        >
          {isCurrentSeason ? 'Previous Meet Events' : 'Season Events'}
        </h2>
        <div
          style={{
            fontSize: '16px',
            fontWeight: '500',
            color: '#495057',
          }}
        >
          {seasonName}
        </div>
      </div>

      <AdminDataTable
        borderType="full"
        isAddedFeatures={false}
        columns={pastMeetsColumns}
        data={pastMeetsData(pastMeets, clubId, openPopup, oldestPlacedByAge)}
        searchInputPlaceholder=""
        headStyle={{
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1.2fr', // 7 columns with flexible sizing
          background: '#f1f1f2',
        }}
        rowStyle={{
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1.2fr', // 7 columns with flexible sizing
        }}
      />
    </>
  );
};

AthletePastMeet.propTypes = {
  pastMeets: PropTypes.array,
  seasonName: PropTypes.string,
  clubId: PropTypes.string,
  openPopup: PropTypes.func,
  isCurrentSeason: PropTypes.bool,
};

export default AthletePastMeet;
